export const SET_IS_PAUSED = 'SET_IS_PAUSED';
export const PUSH_TO_HOLD_QUEUE = 'PUSH_TO_HOLD_QUEUE';
